import postgreApiService from "./apiService";
import { getStoredCompanyId } from "../../utils/user";

const AI_CHAT_CONFIG_ENDPOINT = "/get_ai_chat_config_json";
const AI_CHAT_CONFIG_STORAGE_KEY = "aiChatConfig";

// Response body is a JSON string, not a nested object — confirmed against a
// live call: "{\"AI_CHAT_BASE_URL\":\"...\",\"AI_CHAT_AUTH\":\"...\"}".
export const getAiChatConfig = async () => {
    const response = await postgreApiService.post(AI_CHAT_CONFIG_ENDPOINT, {
        company_id: getStoredCompanyId(),
    });
    const raw = response?.data;
    const parsed = typeof raw === "string" ? JSON.parse(raw) : (raw || {});
    return {
        baseUrl: parsed?.AI_CHAT_BASE_URL || parsed?.ai_chat_base_url || "",
        auth: parsed?.AI_CHAT_AUTH || parsed?.ai_chat_auth || "",
    };
};

export const getStoredAiChatConfig = () => {
    try {
        const raw = localStorage.getItem(AI_CHAT_CONFIG_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
};

const saveAiChatConfig = (config) => {
    try {
        localStorage.setItem(AI_CHAT_CONFIG_STORAGE_KEY, JSON.stringify(config));
    } catch {
        // best-effort — aiagent/apiService.js falls back to fetching fresh if this didn't stick
    }
};

export const clearAiChatConfig = () => {
    try {
        localStorage.removeItem(AI_CHAT_CONFIG_STORAGE_KEY);
    } catch {}
};

// Fetches the config and caches it in localStorage — called once in the
// background right after login and on session restore (see context/index.js),
// so aiagent requests can read it synchronously afterward instead of each
// awaiting a fresh RPC call.
export const refreshAiChatConfig = async () => {
    const config = await getAiChatConfig();
    if (config.baseUrl) saveAiChatConfig(config);
    return config;
};
